import gql from 'graphql-tag';

import type { BlogOutlineSection } from 'src/data/blog';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { Override } from 'src/lib/types';
import type { BackendMutationCreateBlogPostBuilderAllOutlineSectionsArgs } from 'src/types/backend';

import { FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION } from './schema';

const MUTATION = gql`
  mutation CreateBlogPostBuilderAllOutlineSections(
    $projectId: ID!
    $sections: [BlogPostBuilderOutlineSectionInput!]!
  ) {
    createBlogPostBuilderAllOutlineSections(projectId: $projectId, sections: $sections) {
      ...BlogPostBuilderOutlineSection
    }
  }
  ${FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION}
`;

type Variables = Override<
  BackendMutationCreateBlogPostBuilderAllOutlineSectionsArgs,
  {
    sections: BlogOutlineSection[];
  }
>;

export const createBlogPostBuilderAllOutlineSections = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<BlogOutlineSection[]>(result.data);
};
